export interface ExportFamilyBlockerRow {
  id: string;
  role: "admin" | "coach" | "company_admin" | "participant";
  entityFamilies: string;
  availability: string;
}

// Role-scoped CSV exports are a real PRD feature that the backend does not
// serve yet; the Exports screen stays an honest blocked state until it does.
export function getExportFamilyBlockerRows(): ExportFamilyBlockerRow[] {
  return [
    {
      id: "admin-exports",
      role: "admin",
      entityFamilies: "reports, participants, cohorts, history",
      availability: "Not available yet"
    },
    {
      id: "coach-exports",
      role: "coach",
      entityFamilies: "assigned participants, cohorts, reports, history",
      availability: "Not available yet"
    },
    {
      id: "company-admin-exports",
      role: "company_admin",
      entityFamilies: "assigned-company reports, participants, cohorts, sessions, history",
      availability: "Not available yet"
    },
    {
      id: "participant-exports",
      role: "participant",
      entityFamilies: "own downloads only",
      availability: "no export route; downloads stay on report and resource pages"
    }
  ];
}
